import { render, staticRenderFns } from "./ClientProjectsEditProposalsDetails.vue?vue&type=template&id=718472ea&"
import script from "./ClientProjectsEditProposalsDetails.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditProposalsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports